import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type CancelVerificationServiceChangeRequestModalProps = {
    serviceName: string;
    apiKey: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<VerificationServiceChangeRequest>;
};

export const CancelVerificationServiceChangeRequestModal = (props: CancelVerificationServiceChangeRequestModalProps) => {
    const { serviceName, apiKey, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>CANCEL</b> the Change Request for the Verification Service 
                    named <b>{serviceName}</b> with API Key <b>{apiKey}</b>.</p>
                <p>
                    Once the Change Request has been canceled, all undeployed changes that have been made will be rolled back and the Verification Service will be reverted back to its last deployed state.
                    The changes that were made will be kept in the Verification Service History view and can be recovered as long as no additional changes are made to this Verification Service.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.CANCEL}
            title={"Cancel Verification Service Change Request"}
            body={bodyElement}
            buttonText={"Cancel Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};